var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12MinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 18,
    viewBox: "0 0 79 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_529)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2839 17.9344V6.40186H15.9884V4.34131C18.5331 4.28833 20.2839 2.80525 20.6666 1.00635H23.5121V17.9344H20.2839Z",
    fill: "#4357AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5589 15.0442V17.9342H26.3331C26.3835 14.9066 27.3999 12.7515 30.3465 10.8403L33.137 9.01329C34.6487 8.03244 35.3018 6.96656 35.3018 5.68546C35.3018 4.23923 34.362 2.93059 32.4579 2.93059C30.5378 2.93059 29.5712 4.29181 29.5162 6.04074H26.4934C26.4909 5.98571 26.4885 5.93066 26.4885 5.87563C26.4885 2.82052 28.6791 0.0656738 32.5108 0.0656738C36.2392 0.0656738 38.4562 2.60283 38.4562 5.63041C38.4562 7.92236 37.2294 9.80397 35.1965 11.1126L31.9102 13.2423C31.1041 13.7602 30.425 14.171 30.1906 15.0442H38.5589Z",
    fill: "#4357AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4392 17.9343V6.0891H43.4382V7.77624C44.1944 6.41563 45.8425 5.7085 47.3286 5.7085C49.0575 5.7085 50.5704 6.49717 51.273 8.04828C52.2997 6.30706 53.8396 5.7085 55.5419 5.7085C57.9194 5.7085 60.1887 7.23174 60.1887 10.7421V17.9343H57.1627V11.2591C57.1627 9.70798 56.3792 8.53787 54.6231 8.53787C52.9751 8.53787 51.8946 9.84399 51.8946 11.4766V17.9343H48.8147V11.2591C48.8147 9.735 48.058 8.53787 46.2749 8.53787C44.5996 8.53787 43.5461 9.78991 43.5461 11.4766V17.9343H40.4392Z",
    fill: "#4357AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9378 1.00635C64.984 1.00635 65.8311 1.85334 65.8311 2.89937C65.8311 3.9458 64.984 4.76813 63.9378 4.76813C62.9164 4.76813 62.0693 3.9458 62.0693 2.89937C62.0693 1.85334 62.9164 1.00635 63.9378 1.00635Z",
    fill: "#4357AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0693 17.9343H64.8906V6.64893H62.0693V17.9343Z",
    fill: "#4357AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7356 17.9343H67.7124V6.0891H70.6576V7.85778C71.4916 6.33409 73.0031 5.7085 74.411 5.7085C77.5123 5.7085 78.9977 8.04828 78.9977 10.9596V17.9343H75.9747V11.5037C75.9747 9.87103 75.2706 8.56531 73.3682 8.56531C71.6482 8.56531 70.7356 9.95297 70.7356 11.6946V17.9343Z",
    fill: "#4357AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0533 15.2399C4.64583 15.2399 2.69415 13.2882 2.69415 10.8808C2.69415 8.47292 4.64583 6.52124 7.0533 6.52124V10.8804L11.1988 9.52849C11.3377 9.95407 11.4124 10.4091 11.4124 10.8808C11.4124 13.2882 9.46076 15.2399 7.0533 15.2399ZM7.05336 3.82739C3.158 3.82739 0 6.98497 0 10.8808C0 14.7761 3.158 17.9341 7.05336 17.9341C10.9488 17.9341 14.1067 14.7761 14.1067 10.8808C14.1067 6.98497 10.9488 3.82739 7.05336 3.82739Z",
    fill: "#4357AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 17.8688,
    fill: "white",
    transform: "translate(0 0.0656738)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12MinLogo);
export default __webpack_public_path__ + "static/media/12min-logo.537acdf29ca6c4cfc95de59cd1c4875a.svg";
export { ForwardRef as ReactComponent };